import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap";
import {HOTB} from "../../HOTB";

export class AvalancheIdlePresentation implements FlowStatePresentation {
    constructor() {
    }

    start(flowStateController: FlowStateController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: (): void => {
                flowStateController.finish();
            }
        });

        tl.add((): void => {
            HOTB.apiPlugin.betHandler.zeroBet();
        });

        if (tl.duration() === 0) {
            tl.add(gsap.to(this, {duration: 0.001}));
        }
    }
}